var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 97,
    viewBox: "0 0 137 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53904 50.8378L46.1798 94.4785C47.5981 95.8968 49.9038 95.8968 51.3221 94.4785C52.7405 93.0602 52.7405 90.7545 51.3221 89.3362L13.8929 51.907L132.399 51.9069C134.407 51.9069 136.036 50.2777 136.036 48.2702C136.036 46.2627 134.407 44.6335 132.399 44.6335L13.8929 44.6335L51.3221 7.20426C52.7405 5.78594 52.7405 3.48025 51.3221 2.06193C50.6093 1.34913 49.6783 1 48.7473 1C47.8163 1 46.8853 1.3564 46.1725 2.06193L2.53177 45.7027C1.11345 47.121 1.11345 49.4267 2.53177 50.845L2.53904 50.8378Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.7e11d0efad38ac7914c47024f55cdbd7.svg";
export { ForwardRef as ReactComponent };